// Ui
import Text from 'ui3/Text/Text';
import LinkButton from 'ui3/LinkButton/LinkButton';
// Styles
import styles from './OrganizerCard.module.scss';

export type OrganizerCardData = {
  avatarUrl?: string;
  sport?: string;
  firstName?: string;
  lastName?: string;
  role?: string;
  numberOfAudience?: string;
  slug?: string;
};

type OrganizerCardProps = {
  organizer: OrganizerCardData;
};

const OrganizerCard = ({
  organizer: {
    avatarUrl = '/images/icons/avatar-placeholder.svg',
    sport,
    firstName,
    lastName,
    role,
    numberOfAudience,
    slug,
  },
}: OrganizerCardProps) => {
  const profileUrl = slug ? `/${slug}` : undefined;

  return (
    <div className={styles.organizerCard}>
      <img src={avatarUrl} alt="Organizer avatar" className={styles.avatar} />
      <div className={styles.info}>
        <div className={styles.sportChip}>{sport}</div>
        <Text variant="body1Medium18" className={styles.name}>
          {firstName} {lastName}
        </Text>
        <div className={styles.details}>
          <Text variant="body2Regular" color="lights-low">
            {role}
          </Text>
          <span className={styles.dot}>•</span>
          <Text variant="body2Regular" color="lights-low">
            <span className={styles.followersNumber}>{numberOfAudience}</span>{' '}
            Audience
          </Text>
        </div>
        {profileUrl && (
          <LinkButton
            variant="secondary"
            className={styles.viewProfileButton}
            size="medium"
            link={profileUrl}
          >
            View Profile
          </LinkButton>
        )}
      </div>
    </div>
  );
};

export default OrganizerCard;
